export default __webpack_public_path__ + "static/media/icons8-wastedisposal.7601cb29.svg";